import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateTimetableForm from "../../forms/CreateOrUpdateTimetableForm";
import { TimetableResponseDto } from "../../shared/dtos/timetable/TimetableResponseDto";
import { TimetableSummaryDto } from "../../shared/dtos/timetable/TimetableSummaryDto";

interface UpdateTimetableModalProps {
  open: boolean;
  onClose: () => void;
  timetable: TimetableResponseDto | TimetableSummaryDto;
  loading: boolean;
  error?: string | null;
}

const UpdateTimetableModal: React.FC<UpdateTimetableModalProps> = ({
  open,
  onClose,
  timetable,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`Update Status: ${timetable.name}`}
      width="sm"
      loading={loading}
    >
      <CreateOrUpdateTimetableForm
        isEditing={true}
        timetable={timetable as any}
        loading={loading}
        error={error}
      />
    </AppModal>
  );
};

export default UpdateTimetableModal;
